<p-table
  [columns]="columns()"
  [value]="dataSliced()"
  [(selection)]="selectedItems"
  selectionMode="multiple"
  [dataKey]="dataKey()"
  (onRowSelect)="onSelectChange()"
  (onRowUnselect)="onSelectChange()"
  (onHeaderCheckboxToggle)="onHeaderCheckboxToggle($event)"
  [stripedRows]="stripedRows()"
  [loading]="loading()"
  (onSort)="onSort($event)"
  [lazy]="true"
  selectionPageOnly
>
  <ng-template #header let-columns>
    <tr [ngClass]="classToApply.container()">
      @if (showCheckbox()) {
        <th class="flex flex-col justify-center col-span-1">
          <p-tableHeaderCheckbox class="flex justify-center" />
        </th>
      }

      @for (col of columns; track col.headerName; let idx = $index) {
        <th
          [pSortableColumn]="col.field"
          [pSortableColumnDisabled]="!col.sortable"
          class="text-sm"
          [ngClass]="classToApply.item(idx)"
        >
          <span
            class="flex justify-between text-sm"
            [ngClass]="{ 'mb-1': !!col.headerComponent }"
          >
            {{ col.headerName }}
            @if (col.sortable) {
              <span class="flex material-symbols-outlined"> unfold_more </span>
            }
          </span>
          <ng-container appDatatableHeaderAnchor />
        </th>
      }
    </tr>
  </ng-template>
  <ng-template #body let-rowData let-columns="columns">
    <tr
      [ngClass]="classToApply.container()"
      (click)="onRowClicked(rowData)"
      class="cursor-pointer hover:bg-gray-50"
    >
      @for (col of columns; track col.field; let idx = $index) {
        @if (showCheckbox() && idx === 0) {
          <td class="flex flex-col justify-center col-span-1">
            <p-tableCheckbox class="flex justify-center" [value]="rowData" />
          </td>
        }
        <td
          [ngClass]="classToApply.item(idx)"
          class="flex flex-col justify-center"
        >
          <ng-container appDatatableCellAnchor />
        </td>
      }
    </tr>
  </ng-template>
</p-table>
@if (paginate()) {
  <app-paginator
    #paginator
    [totalRecords]="totalRecords()"
    [rows]="rowsPerPage()"
    (pageChange)="onTableChange()"
  />
}
